<template>
    <div style="min-height: 92vh" class="pa-4">
        <div class="d-flex align-center mb-4">
            <h3 class="text-h5 font-weight-bold">Gestión de Planes</h3>
            <v-spacer></v-spacer>
        </div>

        <uv-data-table :config="config" :data="planes" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>

        <modal v-model="showModal" :showFooter="false" :fullscreen="true"
            :title="editMode ? 'Editar Plan' : 'Nuevo Plan'">
            <PlanesForm :edit="editMode" :key="formKey" :dataEdit="editData" @toggle="showModal = false"
                @successData="successData" />
        </modal>
    </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import PlanesForm from "./PlanesForm.vue";

export default {
    name: "Planes",
    components: {
        modal,
        uvDataTable,
        PlanesForm,
    },
    data() {
        return {
            showModal: false,
            editMode: false,
            editData: {},
            formKey: 0,
            planes: [],
            config: {
                selectableRow: true,
                orderByCol: { Field: "Nombre", Type: "Asc" },
                allowExport: true,
                rawText: "Planes",
                selectConfig: {
                    idRowData: "Id",
                },
                buttons: [
                    {
                        text: "Agregar",
                        icon: "mdi-plus",
                        buttonId: "addPlan",
                    },
                    {
                        text: "Editar",
                        icon: "mdi-pencil",
                        buttonId: "editPlan",
                        require: true,
                    },
                    {
                        text: "Eliminar",
                        icon: "mdi-trash-can-outline",
                        buttonId: "deletePlan",
                        require: true,
                    },
                ],
                fields: [
                    {
                        text: "Nombre del Plan",
                        value: "nm",
                    },
                    {
                        text: "Precio",
                        value: "pc",
                        format: (row) => {
                            const price = typeof row.pc === 'object' && row.pc !== null ? row.pc.C : row.pc;
                            return `<span class="font-weight-bold">$${Number(price).toLocaleString("es-MX", { minimumFractionDigits: 2 })}</span>`;
                        },
                    },
                    {
                        text: "Beneficios",
                        value: "bf",
                        format: (row) => {
                            if (!row.bf || row.bf.length === 0) return "Sin beneficios";
                            return row.bf
                                .map((b) => `<v-chip small>${b.nm}</v-chip>`)
                                .join(", ");
                        },
                    },
                    {
                        text: "Cant. Beneficios",
                        value: "cantBeneficios",
                        format: (row) => {
                            return row.bf ? row.bf.length : 0;
                        },
                    },
                ],
            },
        };
    },
    methods: {
        async getPlanes() {
            const firestore = this.$store.getters.getFirebaseApp.firestore;
            const data = await firestore.queryBuilder("MBR_Planes", [
                firestore.where(
                    "Tenant",
                    "==",
                    this.$store.getters.getFirebaseApp.tenant
                ),
            ]);
            if (data.empty) {
                this.planes = this.getMockData();
            } else {
                let doc = data.docs.map((doc) => {
                    return { Id: doc.ref.id, ...doc.data() };
                });
                this.planes = doc;
            }
        },
        getMockData() {
            return [];
        },
        dtButtonClick(buttonId, idSelected) {
            if (buttonId === "addPlan") {
                this.editMode = false;
                this.editData = {};
                this.formKey++;
                this.showModal = true;
            } else if (buttonId === "editPlan") {
                this.editMode = true;
                this.editData = this.planes.find(e => e.Id === idSelected[0]);
                this.formKey++;
                this.showModal = true;
            } else if (buttonId === "deletePlan") {
                this.deletePlan(idSelected[0]);
            }
        },
        successData(data, mode) {


            if (mode === "CREATE") {
                this.$alert.alertConfirm({
                    action: "crear",
                    obj: "el plan",
                    route: "MBR-Planes-createPlan",
                    data: data,
                    onSuccess: () => {
                        this.getPlanes();
                        this.showModal = false;
                    },
                });
            } else {
                console.log(JSON.stringify(data))
                this.$alert.alertConfirm({
                    action: "actualizar",
                    obj: "el plan",
                    route: "MBR-Planes-actualizarPlan",
                    data: data,
                    onSuccess: () => {
                        this.getPlanes();
                        this.showModal = false;
                    },
                });
            }
        },
        deletePlan(id) {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("Id", id);
            formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
            this.$alert.alertConfirmFormData({
                action: "eliminar",
                route: "MBR-Planes-eliminarPlan",
                data: formData,
                obj: "el plan",
                onSuccess: () => {
                    this.getPlanes();
                },
            });
        },
    },
    mounted() {
        this.getPlanes();
    },
};
</script>

<style scoped>
.text-h5 {
    color: #333;
}
</style>
